const remove = function () {
  localStorage.removeItem('user-token')
  localStorage.removeItem('user-refresh')
  localStorage.removeItem('user-info')
}

const saveToken = function (resp) {
  localStorage.setItem('user-token', resp.access_token)
  localStorage.setItem('user-refresh', resp.refresh_token)
}

const saveUserData = function (data) {
  localStorage.setItem('user-data', JSON.stringify(data))
}

const getToken = function () {
  return localStorage.getItem('user-token')
}

const getRefreshToken = function () {
  return localStorage.getItem('user-refresh')
}

const getUserData = function () {
  return JSON.parse(localStorage.getItem('user-data'))
}

export default {
  remove,
  saveUserData,
  getToken,
  getRefreshToken,
  getUserData,
  saveToken
}



// WEBPACK FOOTER //
// ./src/store/modules/authComponents/storage.js